import { render, staticRenderFns } from "./OnlineMessage.vue?vue&type=template&id=aa6d41fa&scoped=true&"
import script from "./OnlineMessage.vue?vue&type=script&lang=js&"
export * from "./OnlineMessage.vue?vue&type=script&lang=js&"
import style0 from "./OnlineMessage.vue?vue&type=style&index=0&id=aa6d41fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6d41fa",
  null
  
)

export default component.exports